module.exports = __webpack_public_path__ + "media/brand/PhotokiveLogo-b2d11af4.svg";